import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/web.dom.iterable";
import * as types from './types';
import { fetchCustomizable } from '~/services/customizable';
export default {
  fetchConfigurator(_ref, _ref2) {
    let {
      commit
    } = _ref;
    let {
      model
    } = _ref2;
    const configuration = fetchCustomizable(this, model);
    const base = import('~/api/configurator/config.json');
    Promise.all([configuration, base]).then(values => {
      if (!values[0].status) {
        const {
          currentLocale
        } = this.state.i18n;
        const urlRedirect = values[1].details.backUrl;
        this.app.context.redirect("/".concat(currentLocale.market, "/").concat(currentLocale.language, "/e/").concat(urlRedirect) || '/');
      }

      const _values$0$payload = values[0].payload,
            {
        options,
        price
      } = _values$0$payload,
            information = _objectWithoutProperties(_values$0$payload, ["options", "price"]);

      commit(types.SET_DEFAULT_CUSTOMIZABLE, {
        options,
        price,
        model,
        information: _objectSpread({}, information, values[1].details)
      });
      commit(types.SET_OPTIONS, options.map(option => _objectSpread({}, option, {
        config: values[1].config[option.name]
      })));
    }).catch(error => {
      this.$logger.error(error);
    });
  }

};